"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressCap = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const slate_react_1 = require("slate-react");
const slate_1 = require("slate");
const context_1 = require("@jsonjoy.com/ui/lib/styles/context");
const use_t_1 = require("use-t");
const x_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/x"));
const CloseIcon = (props) => (React.createElement(x_1.default, { width: 14, height: 14, ...props }));
const rowClass = (0, nano_theme_1.rule)({
    d: 'flex',
    ai: 'center',
    jc: 'space-between',
    gap: '8px',
    pad: '0 0 10px 0',
    mar: '0 0 6px 0',
    fz: '12px',
    lh: 1.4,
});
const labelClass = (0, nano_theme_1.rule)({
    d: 'inline-flex',
    ai: 'center',
    gap: '8px',
    fw: 500,
});
const trackClass = (0, nano_theme_1.rule)({
    pos: 'relative',
    d: 'inline-block',
    w: '120px',
    h: '4px',
    bdrad: '4px',
    ov: 'hidden',
});
const fillClass = (0, nano_theme_1.rule)({
    pos: 'absolute',
    t: 0,
    l: 0,
    h: '100%',
    trs: 'width .2s ease, background-color .2s ease',
    bdrad: '4px',
});
const closeClass = (0, nano_theme_1.rule)({
    d: 'inline-flex',
    ai: 'center',
    jc: 'center',
    w: '20px',
    h: '20px',
    pad: 0,
    bd: 'none',
    bg: 'transparent',
    bdrad: '4px',
    cur: 'pointer',
    op: 0.55,
    trs: 'opacity .12s, background-color .12s',
    '&:hover': {
        op: 1,
    },
});
const countDone = (children) => {
    let n = 0;
    for (const c of children)
        if (c.stepState === 'done')
            n++;
    return n;
};
/** Cap row above a stepper list summarizing how many items are `done` of the total. */
const ProgressCap = ({ element }) => {
    const editor = (0, slate_react_1.useSlateStatic)();
    const readOnly = (0, slate_react_1.useReadOnly)();
    const styles = (0, context_1.useStyles)();
    const [t] = (0, use_t_1.useT)();
    const total = element.children.length;
    const done = countDone(element.children);
    const pct = total > 0 ? Math.round((done / total) * 100) : 0;
    const onDismiss = React.useCallback(() => {
        if (readOnly)
            return;
        try {
            const path = slate_react_1.ReactEditor.findPath(editor, element);
            slate_1.Transforms.unsetNodes(editor, 'progress', { at: path });
        }
        catch { }
    }, [editor, element, readOnly]);
    const positive = styles.positive.toString();
    const trackBg = styles.g(0.85);
    const labelColor = styles.g(0.4);
    const allDone = total > 0 && done === total;
    return (React.createElement("div", { role: "status", "aria-live": "polite", "aria-label": t('Stepper progress'), className: rowClass, contentEditable: false, style: { color: labelColor } },
        React.createElement("span", { className: labelClass },
            React.createElement("span", null, t('Progress')),
            React.createElement("span", { className: trackClass, style: { background: trackBg }, "aria-hidden": "true" },
                React.createElement("span", { className: fillClass, style: { width: `${pct}%`, background: positive } })),
            React.createElement("span", { style: { fontVariantNumeric: 'tabular-nums' } },
                done,
                " / ",
                total,
                " ",
                allDone ? t('done') : '')),
        !readOnly && (React.createElement("button", { type: "button", className: closeClass, "aria-label": t('Hide progress'), onMouseDown: (e) => {
                e.preventDefault();
                e.stopPropagation();
            }, onClick: onDismiss },
            React.createElement(CloseIcon, null)))));
};
exports.ProgressCap = ProgressCap;
